/* eslint-disable import/prefer-default-export */

// Default same-origin path for the local dev-only ACH proxy (see ach/proxy.ts + vite.config.ts); not a real endpoint.
export const DEFAULT_ACH_PROXY_PREFIX = '/ach-dev-only-proxy';
export const ACH_CONTRACTS_KPI_PERFORMANCE_URL = '/api/admin/v2/contracts/kpi_performance';
export const ACH_CONTRACTS_PACING_URL = '/api/admin/v2/contracts/pacing';
// ACH-bj8d rollback switch. 'deferred' opts contract/insertion-order reads out of the
// inline BigQuery spend read (ACH's ?spend=deferred), which the contracts grid then
// lazy-loads from ACH_CONTRACTS_PACING_URL. Set to undefined to revert every call site
// to today's inline payload in one line: query-string omits undefined values and
// useContractsPacing stops fetching.
export const SPEND_DEFERRED: string | undefined = 'deferred';
export const ACH_CAMPAIGN_READINESS_URL = '/api/admin/v2/campaigns/:id/readiness';
export const ACH_BOARD_URL = '/api/admin/v2/board';
export const ACH_BOARD_ACK_GROUP_URL = '/api/admin/v2/board/acknowledge';
export const ACH_BOARD_ISSUE_ACK_URL = '/api/admin/v2/board/issues/:id/acknowledge';
